<template>
  <Loading
    v-model:active="isLoading"
    :can-cancel="false"
    :is-full-page="isFullPage"
    :height="32"
    :width="32"
    color="#5e81f4"
    loader="spinner"
    :lock-scroll="true"
    :z-index="10000"
  >
    <template #before>
      <p class="loading-text">読み込み中</p>
    </template>
  </Loading>
</template>

<script setup>
import Loading from 'vue-loading-overlay';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import 'vue-loading-overlay/dist/css/index.css';

const store = useStore();
const isLoading = computed(() => store.getters['common/isLoading']);
const isFullPage = ref(true);
</script>
<style scoped>
:deep(.vl-icon) {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
